import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  REFRESHTOKEN_USER_INTERVAL,
  REFRESHTOKEN_USER,
  REFRESHTOKEN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  CHANGEPASSWORD,
  CHANGEPASSWORD_SUCCESS,
  FORGOTPASSWORD,
  FORGOTPASSWORD_SUCCESS,
  CONFIRMFORGOTPASSWORD,
  CONFIRMFORGOTPASSWORD_SUCCESS,
  UPDATEACCOUNT,
  UPDATEACCOUNT_SUCCESS,
  DELETEACCOUNT,
  DELETEACCOUNT_SUCCESS,
  CHECKTYPE_USER,
  CHECKTYPE_USER_SUCCESS,
  GETACCOUNT,
  GETACCOUNT_SUCCESS,
  ENABLEACCOUNT,
  ENABLEACCOUNT_SUCCESS,
  DISABLEACCOUNT,
  DISABLEACCOUNT_SUCCESS
} from "constants/ActionTypes";

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const userCheckType = () => {
  return {
    type: CHECKTYPE_USER
  };
};
export const userRefreshToken = (refreshToken) => {
  return {
    type: REFRESHTOKEN_USER,
    payload: refreshToken
  };
};
export const userRefreshTokenInterval = (refreshToken) => {
  return {
    type: REFRESHTOKEN_USER_INTERVAL,
    payload: refreshToken
  };
};
export const userSignOut = () => {
  console.log('userSignOut');
  return {
    type: SIGNOUT_USER
  };
};

export const changePassword = (previousPassword, proposedPassword) => {
  console.log('changePassword', previousPassword, proposedPassword);
  return {
    type: CHANGEPASSWORD,
    payload: {previousPassword, proposedPassword}
  };
};

export const forgotPassword = (email) => {
  console.log('forgotPassword', email);
  return {
    type: FORGOTPASSWORD,
    payload: {email}
  };
};

export const confirmForgotPassword = ({email, confirmationCode, password}) => {
  return {
    type: CONFIRMFORGOTPASSWORD,
    payload: {email, confirmationCode, password}
  };
};

export const userSignUpSuccess = (signedUpUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: signedUpUser
  };
};

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};

export const userCheckTypeSuccess = (payload) => {
  console.log('userCheckTypeSuccess', payload);
  return {
    type: CHECKTYPE_USER_SUCCESS,
    payload: payload
  }
};

export const changePasswordSuccess = (changedPassword) => {
  return {
    type: CHANGEPASSWORD_SUCCESS,
    payload: changedPassword
  }
};

export const forgotPasswordSuccess = (forgotPassword) => {
  return {
    type: FORGOTPASSWORD_SUCCESS,
    payload: forgotPassword
  }
};

export const confirmForgotPasswordSuccess = (confirmForgotPassword) => {
  return {
    type: CONFIRMFORGOTPASSWORD_SUCCESS,
    payload: confirmForgotPassword
  }
};

export const userRefreshTokenSuccess = (accessToken) => {
  return {
    type: REFRESHTOKEN_USER_SUCCESS,
    payload: accessToken
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};
export const userChangePasswordSuccess = (success) => {
  return {
    type: CHANGEPASSWORD_SUCCESS,
    payload: success
  }
};
export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const userGoogleSignIn = () => {
  return {
    type: SIGNIN_GOOGLE_USER
  };
};
export const userGoogleSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GOOGLE_USER_SUCCESS,
    payload: authUser
  };
};
export const userFacebookSignIn = () => {
  return {
    type: SIGNIN_FACEBOOK_USER
  };
};
export const userFacebookSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_FACEBOOK_USER_SUCCESS,
    payload: authUser
  };
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
export const userTwitterSignIn = () => {
  return {
    type: SIGNIN_TWITTER_USER
  };
};
export const userTwitterSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_TWITTER_USER_SUCCESS,
    payload: authUser
  };
};
export const userGithubSignIn = () => {
  return {
    type: SIGNIN_GITHUB_USER
  };
};
export const userGithubSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GITHUB_USER_SUCCESS,
    payload: authUser
  };
};
export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

export const updateAccount = (updatingAccount) => {
  return {
    type: UPDATEACCOUNT,
    payload: updatingAccount
  };
};

export const updateAccountSuccess = (updatedAccount) => {
  return {
    type: UPDATEACCOUNT_SUCCESS,
    payload: updatedAccount
  }
};

export const deleteAccount = (accountId) => {
  return {
    type: DELETEACCOUNT,
    payload: accountId
  };
};

export const deleteAccountSuccess = (deletedAccount) => {
  return {
    type: DELETEACCOUNT_SUCCESS,
    payload: deletedAccount
  }
};

export const enableAccount = (accountId) => {
  return {
    type: ENABLEACCOUNT,
    payload: accountId
  };
};

export const enableAccountSuccess = (enabledAccount) => {
  return {
    type: ENABLEACCOUNT_SUCCESS,
    payload: enabledAccount
  }
};

export const disableAccount = (accountId) => {
  return {
    type: DISABLEACCOUNT,
    payload: accountId
  };
};

export const disableAccountSuccess = (disabledAccount) => {
  return {
    type: DISABLEACCOUNT_SUCCESS,
    payload: disabledAccount
  }
};

export const getAccount = () => {
  return {
    type: GETACCOUNT
  };
};

export const getAccountSuccess = (account) => {
  console.log('account', account);

  return {
    type: GETACCOUNT_SUCCESS,
    payload: account
  };
};
